import axios from 'axios';
export class RequestService {
    static get(url) {
        return axios.get(url, this.createConfig());
    }
    static post(url, data) {
        return axios.post(url, data, this.createJsonConfig());
    }
    static patch(url, data) {
        return axios.patch(url, data, this.createJsonConfig());
    }
    static del(url) {
        return axios.delete(url, this.createConfig());
    }
    static createConfig() {
        return {
            headers: {
                'Access-Control-Allow-Origin': window.location.origin
            }
        };
    }
    static createJsonConfig() {
        return {
            headers: {
                'Access-Control-Allow-Origin': window.location.origin,
                'Content-Type': 'application/json'
            }
        };
    }
}
